<template>
  <l-map
    ref="map"
    :center="center"
    :options="mapOptions"
    :style="style"
    :zoom="internalZoom"
    style="width: 100%"
    @update:center="centerUpdate"
    @update:zoom="zoomUpdate"
  >
    <l-tile-layer :url="url" />
    <l-marker :lat-lng="location" />
  </l-map>
</template>

<script>
import { latLng } from "leaflet";
import { LMap, LMarker, LTileLayer } from "vue2-leaflet";

export default {
  name: "simple-map",

  components: {
    LMap,
    LTileLayer,
    LMarker,
  },
  props: {
    lat: Number,
    lng: Number,
    zoom: Number,
    height: {
      type: String,
      default: "500px",
    },
  },

  data() {
    return {
      internalZoom: 13,
      center: this.location,
      url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
      },
    };
  },

  computed: {
    style() {
      return {
        height: this.height,
      };
    },
    location() {
      return latLng(this.lat, this.lng);
    },
  },

  watch: {
    location() {
      this.center = this.location;
    },
  },

  created() {
    this.internalZoom = this.zoom || this.internalZoom;
  },
  methods: {
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
  },
};
</script>
